import analyticstracker from "@jmc/analyticstracker";
import { useEventListener } from "@jmc/utils/hooks/useEventListener";
import { useOnScreen } from "@jmc/utils/hooks/useOnScreen";
import { useCookieInteraction } from "@jmc/core/src/hooks/useCookieInteraction/index";
import { EventTypes } from "@jmc/core/src/types/EventTypes";
import React, { useRef, useEffect } from "react";

export interface PropTypes {
    children: JSX.Element | JSX.Element[];
    type: string;
    category?: string;
    eventstatus?: string;
    eventpurpose?: string;
    name: string;
    placement: string;
    position: number;
    targeturl?: string;
    status?: string;
    completeness?: string;
    customClickEvent?: (event: Event) => void;
    thresholdvalue?: number;
}

export const CardImpression: React.FunctionComponent<PropTypes> = (props: PropTypes) => {
    const {
        children,
        type,
        category = null,
        name,
        placement,
        position,
        targeturl = null,
        eventstatus = null,
        eventpurpose = null,
        status = null,
        completeness = null,
        customClickEvent = (e: Event) => analyticstracker().trackInteraction(e, { changeEvent: EventTypes.CARD_CLICK }),
        thresholdvalue = 0,
    } = props;
    const { interacted } = useCookieInteraction();

    const cardContainer = useRef<HTMLDivElement>(null);
    const inViewport = useOnScreen(cardContainer, thresholdvalue);

    useEventListener("click", customClickEvent, cardContainer);

    useEffect(() => {
        if (inViewport && interacted) {
            setTimeout(() => {
                analyticstracker().trackImpression(EventTypes.CARD_IMPRESSION, {
                    info: { targeturl: targeturl },
                });
            }, 1000);
        }
    }, [inViewport, interacted]);

    return (
        <div
            role="none"
            data-tracking-event={EventTypes.CARD_IMPRESSION}
            data-tracking-info={JSON.stringify({
                type,
                category,
                eventstatus,
                eventpurpose,
                name,
                placement,
                position,
                status,
                completeness,
                targeturl,
            })}
            style={{ height: "100%", width: "100%" }}
            ref={cardContainer}
        >
            {children}
        </div>
    );
};

export default CardImpression;
